import React, { 
    useState, 
    useEffect 
} from 'react';
import { 
    Col, 
    Row, 
    Card, 
    Form,
    Badge, 
    Button
} from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Portuguese } from "flatpickr/dist/l10n/pt";
import { DebounceInput } from 'react-debounce-input';
import Flatpick from 'react-flatpickr';
import moment from 'moment';
import axios from 'axios';
import 'moment/locale/pt-br';

// componentes
import { FechamentoComponent } from './components';
import Carregador from './../../Componentes/Carregador';
import InputData from '../../Componentes/InputData';
import Registro from './Registro';
import ModalConfirmar from './../../Componentes/ModalConfirmar';
import ModalEditar from './ModallEditar';
import PaginacaoComponente from '../../Componentes/Paginacao';
import ComboCliente from '../../Componentes/ComboCliente';
import ModalConfirmarFechamento from './ModalConfirmarFechamento';

// consulta
export default function Fechamento() {
    
    // resgata data pelo parametro de rota
    const { dataMes } = useParams();
    
    // cria referencia para picker
    const dataValidadeBoletoRef = React.createRef();

    // estados
    const [parametros, alterarParametros] = useState({
        data: dataMes ?? null,
        pagina: 1,
        registrosPorPagina: 50,
        pesquisa: ''
    });
    const [carregando, mostrarCarregando] = useState(false);
    const [consulta, alterarConsulta] = useState([]);
    const [confirmarFechamento, alterarConfirmarFechamento] = useState(null);
    const [fazendoFechamento, alterarFazendoFechamento] = useState(false);
    const [fazendoRelatorioPlano, alterarFazendoRelatorioPlano] = useState(false);
    const [fazendoRelatorioPlanoAgrupado, alterarFazendoRelatorioPlanoAgrupado] = useState(false);
    const [fazendoFechamentoMassa, alterarFazendoFechamentoMassa] = useState(false);
    const [fazendoRelatorioParcial, alterarFazendoRelatorioParcial] = useState(false);
    const [fazendoRelatorioMensal, alterarFazendoRelatorioMensal] = useState(false);
    const [idClienteRelatorioSelecionado, alterarIdClienteRelatorioSelecionado] = useState(null);
    const [clicouDesabilitarTodosFechamento, alterarClicouDesabilitarTodosFechamento] = useState(true);
    const [clicouDesabiltiarTodosBoleto, alterarClicouDesabilitarTodosBoleto] = useState(true);
    const [modalEdicao, alterarModalEdicao] = useState({
        mostrar: false,
        registro: null
    });
    const [confirmarFechamentoMassa, alterarConfirmarFechamentoMassa] = useState(null);
    const [valorMinimo, alterarValorMinimo] = useState("9.90");
    const [dataValidadeBoleto, alterarDataValidadeBoleto] = useState(dataMes ? moment(dataMes).add(1, 'M').format('YYYY-MM-12') : '');
    const [totalRegistros, alterarTotalRegistros] = useState(0);    
    const [quantidadeRegistrosFechados, alterarQuantidadeRegistrosFechados] = useState(0);

    // função para percorrer os registros (clientes) e verificar sua seleção de gerar boleto e fechamento
    const montaSelecaoCheckboxConsulta = ({
        registros=[],
        forcarSelecaoFechamento=null,
        forcarSelecaoBoleto=null
    }) => {
        // se mandou array vazio, só retorna
        if(registros?.length === 0) return registros;

        // percorre registros e monta a seleção
        const percorreRegistros = registros.map((r) => {
            const clienteDesabilitado = r.cliente.clienteDesabilitado;
            let permiteSelecionarFechamento = clienteDesabilitado === "N";
            let permiteSelecionarBoleto = (
                clienteDesabilitado === "S" || 
                (
                    r.dados.possuiBoletos === "S" &&
                    r.dados.possuiBoletosEmAberto === "N"
                    && r.dados.possuiEventos === "S"
                ) || 
                !r.cliente.idAsaas ? false : true
            );

            // caso cliente não estiver desabilitado
            if(clienteDesabilitado === "N") {
                // se estiver forçando o valor da seleção do fechamento, e se estiver permitindo sua alteração
                if((forcarSelecaoFechamento !== null) && permiteSelecionarFechamento) {
                    // altera o valor pelo o que foi passado no parametro
                    permiteSelecionarFechamento = forcarSelecaoFechamento;
                }

                // se estiver forçando o valor de seleção do boleto, e se estiver permitindo sua alteração
                if((forcarSelecaoBoleto !== null) && permiteSelecionarBoleto) {
                    // altera o valor pelo o que foi passado no parametro
                    permiteSelecionarBoleto = forcarSelecaoBoleto;
                }
            }
            
            // retorna cliente e sua seleção
            return {
                ...r,
                selecionado: permiteSelecionarFechamento,
                selecionadoBoleto: permiteSelecionarBoleto
            }
        });

        return percorreRegistros;
    }

    // consulta registros
    async function consultarRegistros() {

        // mostra carregamento
        mostrarCarregando(true);

        try {

            // faz a requisição
            const { data } = await axios.get('/seguroAventura/fechamentos', { params: parametros });

            // altera registros 
            alterarConsulta(montaSelecaoCheckboxConsulta({
                registros: data.registros
            }));

            // resgata total de registros
            alterarTotalRegistros(parseInt(data.totalRegistros));


        } catch (e) {
            console.log(e);
        } finally {

            // esconde carregamento
            mostrarCarregando(false);

        }
    }

    // faz fechamento de seguro
    async function fazerFechamento() {

        // faz o carregamento
        alterarFazendoFechamento(true)

        try {

            // faz a requisição
            await axios.post(`/seguroAventura/fechamentoCartaOferta`, {
                dados: {
                    cartaOferta: confirmarFechamento.dados.cartaOferta,
                    data: parametros.data,
                    simular: "N",
                    valorMinimo: valorMinimo ? valorMinimo.replace(',', '.') : null,
                    seguroValorDiariaEditado: confirmarFechamento.cliente.seguroValorDiariaEditado ? parseFloat(confirmarFechamento.cliente.seguroValorDiariaEditado) : null,
                    idCliente: confirmarFechamento.cliente.id,
                    dataVencimento: dataValidadeBoleto === '' ? null : dataValidadeBoleto,
                    fazFechamento: confirmarFechamento.selecionado,
                    geraBoleto: confirmarFechamento.selecionadoBoleto
                }
            });

            alterarConfirmarFechamento(null);
            consultarRegistros();

        } catch (e) {

            // se veio retorno
            if (e.response && e.response.data) {

                // resgata primeiro erro
                const erro = Object.entries(e.response.data)[0];

                // resgata chave e valor do erro
                const [chave, valor] = erro;

                toast(({ closeToast }) => <>
                    <div className="toast-header bg-danger text-white">
                        <strong className="mr-auto">{chave.charAt(0).toUpperCase() + chave.slice(1)}</strong>
                        <button
                            onClick={closeToast}
                            className="ml-2 mb-1 close btn-outline-light outline-0"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="toast-body  bg-danger text-white">
                        {valor}
                    </div>
                </>, { autoClose: 10000 });
            }

        } finally {
            alterarFazendoFechamento(false);
        }
    }
    
    // faz fechamento de seguro
    async function fazerFechamentoMassa() {

        // verifica se está pesquisando
        if(parametros.pesquisa.length > 0) {

            return toast(({ closeToast }) => <>
                <div className="toast-header bg-warning text-white">
                    <strong className="mr-auto">Aviso</strong>
                    <button
                        onClick={closeToast}
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body  bg-warning text-white">
                    Limpe a pesquisa para o funcionamento do fechamento em massa.
                </div>
            </>, { autoClose: 10000 })

        }

        // mostra carregamento 
        alterarFazendoFechamentoMassa(true);

        // prepara desselecionados
        let desselecionados = [];
        let desselecionadosBoleto = [];

        // percorre registros
        consulta.forEach(c => {

            // se registro estiver desselecionado
            if (!c.selecionado) {

                // adiciona id ao array
                desselecionados.push(c.dados.id);

            }

            // se registro estiver desselecionado para boleto
            if (!c.selecionadoBoleto) {

                // adiciona id ao array
                desselecionadosBoleto.push(c.dados.id);

            }

        })

        // cria parametros para requisição de fechamento em massa
        const parametrosRequisicao = {
            data: parametros.data,
            valorMinimo: valorMinimo ? valorMinimo.replace(',', '.') : null,
            desselecionados,
            desselecionadosBoleto,
            dataVencimento: dataValidadeBoleto === '' ? null : dataValidadeBoleto
        }

        // resgata dados de requisição do axios
        const urlBase = axios.defaults.baseURL;
        const tokenusuario = axios.defaults.headers.common.tokenusuario;

        // abre requisição xml
        const xhr = new XMLHttpRequest();

        // adiciona endereço
        xhr.open('POST', `${urlBase}/seguroAventura/fechamentoCartaOferta/massa`, true);

        // altera headers
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("tokenusuario", tokenusuario);
        
        // envia dados
        xhr.send(JSON.stringify(parametrosRequisicao));

        // ao mudar estado da requisição
        xhr.onreadystatechange = async (e) => {

            // se função foi finalizada
            if(xhr.readyState === XMLHttpRequest.DONE) return;

            // resgata linhas de retorno
            const linhas = e?.target?.responseText.trim().split("\n");
            const ultimaLinha = linhas.length > 0 ? linhas[linhas.length - 1] : null;
            
            // se tiver retorno de linhas
            if(ultimaLinha) {

                // prepara erro
                let retornoErro = null;
                
                    // se linha não for vazia
                    try {
                        // passa json para objeto
                        const obj = JSON.parse(ultimaLinha);
                        
                        // se deu erro ao fechar carta oferta
                        if(obj.tipo === 'erro') {
                            retornoErro = obj;

                        // se estiver atualizando o progresso
                        } else if(obj.tipo === 'progresso') {
                            // altera quantidade registros que já foram fechados
                            alterarQuantidadeRegistrosFechados(obj.totalConcluidos);   
                        }
                    } catch(e) {
                        retornoErro = 'Erro não identificado';
                    }

                // caso teve erro
                if(retornoErro) {
                    try {
                        // faz a conversão do retorno de erros para um objeto
                        const erros = retornoErro.erro;

                        // resgata cliente que houve erro caso tiver retorno dele
                        const clienteErro = retornoErro?.cliente ?? null;
                        
                        // se for array
                        if(Array.isArray(erros)) {
                            // percorre erros
                            erros.forEach(retorno => {
                                toast(({ closeToast }) => <>
                                    <div className="toast-header bg-danger text-white">
                                        <strong className="mr-auto">{retorno.nome}</strong>
                                        <button
                                            onClick={closeToast}
                                            className="ml-2 mb-1 close btn-outline-light outline-0"
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="toast-body  bg-danger text-white">
                                        {retorno.descricao}
                                    </div>
                                </>, { autoClose: 10000 });
                            });
                        } else {
                            // resgata a primeira chave
                            const chaveErro = Object.keys(erros)[0];
                            
                            // mostra toast
                            toast(({ closeToast }) => <>
                                <div className="toast-header bg-danger text-white">
                                    <strong className="mr-auto">Erro {clienteErro ? ` | Cliente: ${clienteErro}` : ``}</strong>
                                    <button
                                        onClick={closeToast}
                                        className="ml-2 mb-1 close btn-outline-light outline-0"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="toast-body  bg-danger text-white">
                                    {erros[chaveErro]}
                                </div>
                            </>, { autoClose: 10000 })
                        }
                    } catch (e) {
                        console.error('erro:', e);
                    } 
                }

            }
        }

        // ao finalizar requisição
        xhr.onload = () => {
            // se deu certo a requisição
            if(xhr.status === 200) {
                // finaliza carregamento
                alterarFazendoFechamentoMassa(false);
                alterarConfirmarFechamentoMassa(null);
                alterarQuantidadeRegistrosFechados(0);

                // consulta registros novamente
                consultarRegistros();
            } else {
                // finaliza carregamento
                alterarFazendoFechamentoMassa(false);

                try {
                    // faz a conversão do retorno de erros para um objeto
                    const erros = JSON.parse(xhr.responseText);
                    
                    // se for array
                    if(Array.isArray(erros)) {
                        // percorre erros
                        erros.forEach(retorno => {
                            toast(({ closeToast }) => <>
                                <div className="toast-header bg-danger text-white">
                                    <strong className="mr-auto">{retorno.nome}</strong>
                                    <button
                                        onClick={closeToast}
                                        className="ml-2 mb-1 close btn-outline-light outline-0"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="toast-body  bg-danger text-white">
                                    {retorno.descricao}
                                </div>
                            </>, { autoClose: 10000 });
                        });
                    } else {
                        // resgata a primeira chave
                        const chaveErro = Object.keys(erros)[0];

                        // mostra toast
                        toast(({ closeToast }) => <>
                            <div className="toast-header bg-danger text-white">
                                <strong className="mr-auto">Erro</strong>
                                <button
                                    onClick={closeToast}
                                    className="ml-2 mb-1 close btn-outline-light outline-0"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="toast-body  bg-danger text-white">
                                {erros[chaveErro]}
                            </div>
                        </>, { autoClose: 10000 })
                    }
                } catch (e) {
                    console.error('erro:', e);
                    return false;
                }                
            }            
        };
          
        // caso acontecer um erro indefinido ou de conexão
        xhr.onerror = () => {
            // cria toast para erro indefinido ou de conexão
            toast(({ closeToast }) => <>
                <div className="toast-header bg-danger text-white">
                    <strong className="mr-auto">Erro!</strong>
                    <button
                        onClick={closeToast}
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body  bg-danger text-white">
                    Houve um erro não encontrado ou de conexão. Por favor, tente novamente
                </div>
            </>, { autoClose: 10000 });
        };
    }
    
    // função para cancelar o fechamento em massa
    async function cancelarFechamentoMassa() {
        // requisição para cancelar fechamento em massa
        await axios.post('/seguroAventura/fechamentoCartaOferta/massa/cancelar');

        // cancela fechamento em massa
        alterarFazendoFechamentoMassa(false);
    }

    // altera dados do registro no banco
    async function alterarRegistroCliente(registro) {

        // mostra carregamento
        mostrarCarregando(true);

        let dadosUsuario = registro.dadosUsuario || {
            id: null,
            login: '',
            senha: '',
            confirmar_senha: ''
        }

        try {

            // altera dados do fechamento
            await axios.post('/clientes', {
                dados: registro.dados,
                grupos: registro.grupos,
                modoUsuario: registro.dadosUsuario ? true : false,
                dadosUsuario
            });

            // esconde carregamento
            mostrarCarregando(false);

            // consulta novamente os registros
            consultarRegistros();

        } catch (e) {
            console.log(e)
        } finally {

            // esconde carregamento
            mostrarCarregando(false);

        }

    }

    // faz relatório parcial para gerar xls
    async function fazerRelatorioParcial() {

        // mostra carregamento
        alterarFazendoRelatorioParcial(true);

        try {

            // faz a requisição
            const { data } = await axios.get('/seguroAventuraFechamento/relatorioParcial', {
                params: {
                    data: dataMes.toString()
                }
            });

            // faz o download
            window.open(
                `${process.env.REACT_APP_URL_ARQUIVOS}/download.php?p=anexosEmail&f=${encodeURIComponent(data.temporario)}&n=${encodeURIComponent(data.nome)}`,
                '_blank'
            );

        } catch (e) {
            console.log(e);
        } finally {
            // esconde carregamento
            alterarFazendoRelatorioParcial(false);
        }

    }

    // faz relatório mensal para gerar xls
    async function fazerRelatorioMensal() {

        // mostra carregamento
        alterarFazendoRelatorioMensal(true);

        try {

            // faz a requisição
            const { data } = await axios.get('/seguroAventura/gerarFaturamentoMensal', {
                params: {
                    data: dataMes.toString()
                }
            });

            if (data.length > 0) {

                toast(({ closeToast }) => <>
                    <div className="toast-header bg-success text-white">
                        <strong className="mr-auto">Sucesso</strong>
                        <button
                            onClick={closeToast}
                            className="ml-2 mb-1 close btn-outline-light outline-0"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="toast-body  bg-success text-white">
                        Verifique sua caixa de entrada em seu e-mail
                    </div>
                </>, { autoClose: 10000 });

            }

        } catch (e) {
            console.log(e);
        } finally {
            // esconde carregamento
            alterarFazendoRelatorioMensal(false);
        }

    }

    // faz relatório mensal por plano para gerar xls
    async function fazerRelatorioPlano() {

        // mostra carregamento
        alterarFazendoRelatorioPlano(true);

        try {

            // faz a requisição
            const { data } = await axios.get('/seguroAventura/gerarRelatorioMensalPorPlano', {
                params: {
                    data: dataMes.toString(),
                    idClienteRelatorio: idClienteRelatorioSelecionado
                }
            });

            if (data.length > 0) {

                toast(({ closeToast }) => <>
                    <div className="toast-header bg-success text-white">
                        <strong className="mr-auto">Sucesso</strong>
                        <button
                            onClick={closeToast}
                            className="ml-2 mb-1 close btn-outline-light outline-0"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="toast-body  bg-success text-white">
                        Verifique sua caixa de entrada em seu e-mail
                    </div>
                </>, { autoClose: 10000 });

            }

        } catch (e) {
            console.log(e);
        } finally {
            // esconde carregamento
            alterarFazendoRelatorioPlano(false);
        }

    }

    // faz relatório mensal do plano mbm de forma agrupada para gerar xls
    async function fazerRelatorioPlanoAgrupado() {

        // mostra carregamento
        alterarFazendoRelatorioPlanoAgrupado(true);

        try {

            // faz a requisição
            const { data } = await axios.get('/seguroAventura/gerarRelatorioMensalPorPlanoAgrupado', {
                params: {
                    data: dataMes.toString(),
                    idClienteRelatorio: idClienteRelatorioSelecionado
                }
            });

            if (data.length > 0) {

                toast(({ closeToast }) => <>
                    <div className="toast-header bg-success text-white">
                        <strong className="mr-auto">Sucesso</strong>
                        <button
                            onClick={closeToast}
                            className="ml-2 mb-1 close btn-outline-light outline-0"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="toast-body  bg-success text-white">
                        Verifique sua caixa de entrada em seu e-mail
                    </div>
                </>, { autoClose: 10000 });

            }
        } catch (e) {
            console.log(e);
        } finally {
            // esconde carregamento
            alterarFazendoRelatorioPlanoAgrupado(false);
        }

    }

    // inicializa
    useEffect(() => {
        consultarRegistros();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [parametros]);
    
    // retorna
    return (
        <FechamentoComponent>
            {confirmarFechamento !== null &&
                <ModalConfirmar
                    mostrar={confirmarFechamento !== null}
                    texto={`Deseja realmente fazer o fechamento da carta oferta ${confirmarFechamento.dados.cartaOferta} ?`}
                    clicouCancelar={() => {
                        alterarConfirmarFechamento(null);
                    }}
                    clicouConfirmar={fazerFechamento}
                    textoCarregando={'Fazendo fechamento, aguarde!'}
                    carregando={fazendoFechamento}
                    textoBotaoConfirmar={''}
                />
            }

            {confirmarFechamentoMassa !== null &&
                <ModalConfirmarFechamento
                    mostrar={confirmarFechamentoMassa !== null}
                    texto={fazendoFechamentoMassa ? 'Realizando o fechamento, por favor aguarde...' : `Deseja realmente fazer o fechamento em massa?`}
                    clicouCancelar={() => alterarConfirmarFechamentoMassa(null)}
                    clicouConfirmar={fazerFechamentoMassa}
                    textoCarregando={'Fazendo fechamento em massa, aguarde!'}
                    carregando={fazendoFechamentoMassa}
                    textoBotaoConfirmar={''}
                    titulo={'Fechamento'}
                    quantidadeItensAtual={quantidadeRegistrosFechados}
                    totalRegistros={totalRegistros}
                    clicouCancelarFechamento={cancelarFechamentoMassa}
                />
            }

            {modalEdicao.mostrar &&
                <ModalEditar
                    clicouCancelar={() => alterarModalEdicao({ mostrar: false })}
                    clicouConfirmar={async (registroAlterado) => {

                        // esconde modal
                        alterarModalEdicao({ mostrar: false })

                        // altera fechamento no banco
                        await alterarRegistroCliente(registroAlterado);

                    }}
                    registro={modalEdicao.registro}
                    valorMinimo={valorMinimo}
                />
            }

            <Row>
                <Col>
                    <Card className="painel-consulta border-0 shadow-sm">
                        <Card.Header className="d-flex">
                            <h4 className="card-title font-weight-bolder flex-grow-1">
                                Fechamento - {moment(parametros.data).format('MM/YYYY')}
                            </h4>
                            <div>
                                <Button
                                    className={'mr-2'}
                                    variant={'padrao'}
                                    size={'sm'}
                                    onClick={fazerRelatorioPlanoAgrupado}
                                    disabled={fazendoRelatorioPlanoAgrupado}
                                >                                                                    
                                    {(fazendoRelatorioPlanoAgrupado) 
                                        ? <>
                                            <FontAwesomeIcon 
                                                className="icone" 
                                                pulse 
                                                icon={["fas", 'spinner']} 
                                            />
                                            <span>Carregando</span>
                                        </> : 'Relatório por plano agrupado'
                                    }
                                </Button>                                
                                <Button
                                    className='mr-2'
                                    variant='padrao'
                                    size='sm'
                                    onClick={fazerRelatorioPlano}
                                    disabled={fazendoRelatorioPlano}
                                >                                                                    
                                    {(fazendoRelatorioPlano) ? <>
                                        <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                                        <span>Carregando</span>
                                    </> : 'Relatório por plano'}
                                </Button>
                                <Button
                                    className='mr-2'
                                    variant='padrao'
                                    size='sm'
                                    onClick={() => fazerRelatorioParcial()}
                                >
                                    {fazendoRelatorioParcial ? '' : 'Relatório parcial'}
                                    {fazendoRelatorioParcial && <>
                                        <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                                        <span>Carregando</span>
                                    </>}
                                </Button>
                                <Button
                                    className='mr-2'
                                    variant='padrao'
                                    size='sm'
                                    onClick={() => fazerRelatorioMensal()}
                                >
                                    {fazendoRelatorioMensal ? '' : 'Gerar faturamento mensal'}
                                    {fazendoRelatorioMensal && <>
                                        <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                                        <span>Carregando</span>
                                    </>}
                                </Button>
                                <Button
                                    className={'mr-2'}
                                    variant={'padrao'}
                                    size={'sm'}
                                    onClick={() => alterarConfirmarFechamentoMassa(true)}
                                >
                                    Fechamento em massa!
                                </Button>
                            </div>
                        </Card.Header>

                        <Row className="d-flex flex-row justify-content-between m-0 mb-2 position-relative" style={{ gap: 5, padding: '0.75rem 1.25rem' }}>
                            <div className="d-flex flex-column align-items-center justify-content-end mr-2" style={{ gap: 3 }}>
                                <span className='w-100' style={{ textAlign: 'left' }}>
                                    Valor mínimo
                                </span>
                                <DebounceInput
                                    placeholder="Ex: 9,90"
                                    debounceTimeout={400}
                                    element={Form.Control}
                                    value={valorMinimo ?? ''}
                                    onChange={(e) => alterarValorMinimo(e.target.value === '' ? null : e.target.value)}
                                    style={{ width: "auto", height: 38 }}
                                />
                            </div>
                            <div style={{ minWidth: 400, marginTop: 27, flex: 1 }}>
                                <ComboCliente 
                                    id={idClienteRelatorioSelecionado}
                                    alterou={novoId => alterarIdClienteRelatorioSelecionado(novoId)}
                                />
                            </div>
                            <div className="d-flex flex-column align-items-center justify-content-end" style={{ gap: 3 }}>
                                <span className='w-100 ml-3' style={{ textAlign: 'left' }}>
                                    Validade do boleto
                                </span>
                                <div className="d-flex align-itens-center">
                                    <Flatpick
                                        ref={dataValidadeBoletoRef}
                                        value={dataValidadeBoleto}
                                        options={{
                                            dateFormat: "Y-m-d",
                                            altFormat: "d/m/Y",
                                            altInput: false,
                                            allowInput: false,
                                            disableMobile: true,
                                            locale: Portuguese,
                                            onChange: (selectedDates, dateStr, instance) => {
                                                if (dateStr === '') dateStr = null;
                                                alterarDataValidadeBoleto(dateStr);
                                            }
                                        }}
                                        render={
                                            ({ 
                                                defaultValue, 
                                                value, 
                                                onChange, 
                                                ...props 
                                            }, ref) => (
                                                <input 
                                                    ref={ref} 
                                                    onChange={(_, dateStr, __) => alterarDataValidadeBoleto(dateStr)} 
                                                    value={dataValidadeBoleto} 
                                                    style={{ visibility: 'hidden', position: 'absolute' }} 
                                                    {...props} 
                                                    defaultValue={defaultValue} 
                                                />
                                            )
                                        }
                                    />
                                    <InputData
                                        size={"sm"}
                                        data={dataValidadeBoleto}
                                        onChange={(data) => alterarDataValidadeBoleto(data)}
                                        style={{ 
                                            marginLeft: 10, 
                                            minWidth: 210, 
                                            height: 38 
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        style={{
                                            cursor: 'pointer',
                                            alignSelf: 'center',
                                            margin: '0px 8px',
                                            width: 25,
                                            height: 25
                                        }}
                                        icon={["fas", 'calendar-day']}
                                        onClick={() => dataValidadeBoletoRef.current.flatpickr.open()}
                                    />
                                </div>
                            </div>
                        </Row>

                        <Row className='d-flex m-0' style={{ padding: '0.75rem 1.25rem' }}>
                            <DebounceInput
                                placeholder="Pesquise pelo nome do cliente ou pelo seu código referência"
                                debounceTimeout={400}
                                element={Form.Control}
                                value={parametros.pesquisa ?? ''}
                                onChange={(e) => alterarParametros({ ...parametros, pesquisa: e.target.value, pagina: 1 })}
                                style={{ flex: 1, height: 38 }}
                            />
                        </Row>

                        <Card.Body>
                            <div className="legenda mb-1">
                                <span><Badge variant="info">n<sup>o</sup></Badge> Participantes</span>
                                <span><Badge variant="primary">n<sup>o</sup></Badge> Diarias</span>
                                <span><Badge variant="success">R$</Badge> Diarias x Valor</span>
                            </div>

                            <table className="table table-hover tabela border">
                                <thead>
                                    <tr>
                                        <th className='text-center'>
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <Form.Check
                                                    type={'checkbox'}
                                                    inline
                                                    checked={clicouDesabilitarTodosFechamento}
                                                    id={'1'}
                                                    label="Fechamento"
                                                    onChange={() => {
                                                        // ativa o carregamento
                                                        mostrarCarregando(true);
                                                        
                                                        // atualiza registros, forçando o valor do checkbox do fechamento
                                                        alterarConsulta((c) => [
                                                            ...montaSelecaoCheckboxConsulta({
                                                                registros: c,
                                                                forcarSelecaoFechamento: !clicouDesabilitarTodosFechamento
                                                            })
                                                        ]);

                                                        // altera o estado
                                                        alterarClicouDesabilitarTodosFechamento(!clicouDesabilitarTodosFechamento);

                                                        // desativa o carregamento
                                                        mostrarCarregando(false);
                                                    }}
                                                    style={{ marginBottom: -2.5 }}
                                                />
                                            </div>
                                        </th>
                                        <th className='text-center'>
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <Form.Check
                                                    type={'checkbox'}
                                                    inline
                                                    checked={clicouDesabiltiarTodosBoleto}
                                                    label="Boleto"
                                                    id={'2'}
                                                    onChange={() => {
                                                        // ativa o carregamento
                                                        mostrarCarregando(true);

                                                        // atualiza registros, forçando o valor do checkbox do fechamento
                                                        alterarConsulta((c) => [
                                                            ...montaSelecaoCheckboxConsulta({
                                                                registros: c,
                                                                forcarSelecaoBoleto: !clicouDesabiltiarTodosBoleto
                                                            })
                                                        ]);

                                                        // atualiza o estado
                                                        alterarClicouDesabilitarTodosBoleto(!clicouDesabiltiarTodosBoleto);

                                                        // desativa o carregamento
                                                        mostrarCarregando(false);
                                                    }}
                                                    style={{ marginBottom: -2.5 }}
                                                />
                                            </div>
                                        </th>
                                        <th className='text-center'>Código Referência</th>
                                        <th>Cliente</th>
                                        <th className="text-right">Status</th>
                                        <th className="text-right">Total</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {consulta.map((registro, indice) =>
                                        <Registro
                                            indice={indice}
                                            key={registro.dados.cartaOferta + indice.toString()}
                                            dados={registro.dados}
                                            diarias={registro.diarias}
                                            cliente={registro.cliente}
                                            fechado={registro.fechado}
                                            selecionado={registro.selecionado}
                                            selecionadoBoleto={registro.selecionadoBoleto}
                                            parametros={parametros}
                                            dataMes={dataMes}
                                            valorMinimo={valorMinimo}
                                            onClickTr={() => {}}
                                            clicouFechar={() => {
                                                alterarConfirmarFechamento(registro);
                                            }}
                                            clicouEditar={() => {
                                                alterarModalEdicao({
                                                    mostrar: true,
                                                    registro
                                                });
                                            }}
                                            clicouCheckBox={(dados) => {
                                                let novaConsulta = [...consulta];
                                                novaConsulta[dados.indice].selecionado = !novaConsulta[dados.indice].selecionado;
                                                alterarConsulta(novaConsulta);
                                            }}
                                            clicouCheckBoxBoleto={(dados) => {
                                                let novaConsulta = [...consulta];
                                                novaConsulta[dados.indice].selecionadoBoleto = !novaConsulta[dados.indice].selecionadoBoleto;
                                                alterarConsulta(novaConsulta);
                                            }}                                            
                                        />
                                    )}
                                </tbody>
                            </table>
                            <PaginacaoComponente
                                pagina={parametros.pagina}
                                registrosPorPagina={parametros.registrosPorPagina}
                                totalRegistros={totalRegistros}
                                alterouPagina={(pagina) => alterarParametros({ ...parametros, pagina })}
                            />
                            {carregando &&
                                <Carregador className="rounded-bottom" />
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </FechamentoComponent>
    )

}
